var spoiler_default = {
  "fontElementMap": "m0Fjz",
  "hideText": "wKtEP",
  "onHoverText": "_0WxOW",
  "hideBlock": "E74B5",
  "smallBlur": "psn2I",
  "mediumBlur": "YzBAc",
  "largeBlur": "jJUXv",
  "hideBlock_gallery": "r2REw",
  "overlay": "cRpE5",
  "overlay_gallery": "XZjip",
  "revealSpoilerBtn": "b3uCh",
  "isMobile": "nJHdN",
  "onHoverBtn": "qWzgb",
  "spoilerWrapper": "hV9Z-",
  "spoilerDescription": "F-Y5c",
  "spoilerContainer": "lWfI4",
  "spoilerContainer_Gallery": "nGqEy"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
